import React from 'react';
import { BulletList, Card, Prereqs, RelatedLinks, useGuideTheme } from './guideBlocks';

const EditCancelGuide: React.FC = () => {
  const { heroPrimary, heroSecondary } = useGuideTheme();
  return (
    <>
      <Prereqs items={['You\u2019re the host or a co-host']} />
      <div className="grid grid-cols-1 gap-8 items-start">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card>
            <h3 className="text-xl font-bold mb-4" style={{ color: heroPrimary }}>What You Can Edit</h3>
            <BulletList items={['Event title and description', 'Date, time, and location', 'Waypoints and route details (Pro)', 'Motorcycle requirements and skill level', 'Participant limit']} />
            <p className="mt-5 text-xs font-semibold" style={{ color: heroSecondary }}>
              If the event time or location changes and riders have joined, confirm Save &amp; Notify after reviewing the change. Notifications are requested only after the update succeeds.
            </p>
          </Card>
          <Card>
            <h3 className="text-xl font-bold mb-4" style={{ color: heroPrimary }}>Canceling Events</h3>
            <p className="text-sm mb-4" style={{ color: heroSecondary, textWrap: 'pretty' }}>
              Cancel the event with a reason so participants can see the change. RidePulse requests cancellation notifications, but delivery and timing are not guaranteed.
            </p>
            <h4 className="text-sm font-bold mb-3" style={{ color: heroPrimary }}>Common Reasons to Cancel:</h4>
            <BulletList items={['Bad weather or unsafe conditions', 'Low turnout or insufficient RSVPs', 'Personal emergency or mechanical issues', 'Safety concerns or road closures']} />
            <p className="mt-5 text-xs font-semibold" style={{ color: heroSecondary }}>
              Cancel as early as possible to give riders time to adjust plans
            </p>
          </Card>
        </div>
      </div>
      <RelatedLinks links={[
        { id: 'create-event', label: 'Create an event' },
        { id: 'check-in', label: 'Check-in' },
      ]} />
    </>
  );
};

export default EditCancelGuide;
